import React, { createContext, useState, useEffect, useContext } from 'react';
import commonApi from '../utils/api';
import { CommonContext } from './CommonContext';
import { useLocation } from 'react-router-dom';
import { format } from 'date-fns';
import moment from 'moment';

export const AssetContext = createContext();

const initialFilters = {
    searchBy: 'product_type',
    searchValue: '',
    status: '',
    dateRange: {
        startDate: moment().subtract(6, 'month').toDate(),
        endDate: moment().add(0, 'month').toDate(),
    },
};

export function AssetContextProvider({ children }) {
    const { user, setModalAlert, setOpenAlert, setAlertMessage, setSeverity } = useContext(CommonContext);
    const location = useLocation();

    const [addModal, setAddModal] = useState(false);
    const [allAsset, setAllAsset] = useState([]);
    const [allData, setAllData] = useState([]);
    const [viewData, setViewData] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [firstLoading, setFirstLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [filters, setFilters] = useState(initialFilters);

    const handleAddModal = () => {
        setAddModal(true);
        setModalAlert(false);
        setOpenAlert(false);
        setAlertMessage('');
        setSeverity('');
    };

    const handleCloseModal = () => {
        setViewData('')
        setIsEdit(false);
        setAddModal(false);
    };

    const onLoadApi = (customFilters = filters) => {
        setFirstLoading(false);
        const userId = location.state?.id || '';

        let payload = {
            ...customFilters,
            user_id: userId,
            start_date: customFilters?.dateRange?.startDate
                ? format(new Date(customFilters.dateRange.startDate), 'yyyy-MM-dd')
                : null,
            end_date: customFilters?.dateRange?.endDate
                ? format(new Date(customFilters.dateRange.endDate), 'yyyy-MM-dd')
                : null,
            admin_id: user?.id
        };

        delete payload.dateRange;

        commonApi.post(`/users/assets/list?page=${page + 1}&per_page=${rowsPerPage}`, payload)
            .then((response) => {
                setFirstLoading(true);
                if (response?.data?.data) {
                    setAllAsset(response?.data?.data);
                    setAllData(response?.data);
                }
            })
            .catch((error) => {
                setFirstLoading(true);
                console.error('Error fetching data:', error);
            });
    };

    useEffect(() => {
        if (location.pathname === '/assets') {
            onLoadApi();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, location.state?.id, page, rowsPerPage]);

    const contextValue = {
        addModal,
        setAddModal,
        allAsset,
        setAllAsset,
        allData,
        setAllData,
        viewData,
        setViewData,
        isLoading,
        setIsLoading,
        firstLoading,
        setFirstLoading,
        isEdit,
        setIsEdit,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
        filters,
        setFilters,
        initialFilters,
        handleAddModal,
        handleCloseModal,
        onLoadApi,
    };

    return <AssetContext.Provider value={contextValue}>{children}</AssetContext.Provider>;
}
